/**
 * promotions.js — trang tổng hợp khuyến mãi (promotions.html): lọc banner theo trạng thái / loại.
 *
 * Markup: [data-promotions] chứa chip button[data-promo-filter] (aria-pressed), banner [data-promo][data-promo-tags]
 *         (vd "live sale" — trạng thái + loại), số đếm [data-promo-count], dòng trống [data-promo-empty].
 *
 * Vì sao lọc trên trình duyệt: cả trang chỉ ~10–15 chương trình đang chạy / sắp mở — đổi nhóm không cần tải lại.
 * Banner bị ẩn bằng [hidden] nên lưới CSS tự dồn chỗ; banner nổi bật / tràn hàng vẫn giữ kích thước khi hiện.
 *
 * WP: giữ nguyên file; archive-promotion.php in data-promo-tags = trạng thái (tính từ promo_start / promo_end) +
 * slug các term promo_type.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var page = document.querySelector('[data-promotions]');
    if (!page) return;

    var banners = [].slice.call(page.querySelectorAll('[data-promo]'));
    var chips = [].slice.call(page.querySelectorAll('[data-promo-filters] [data-promo-filter]'));
    var count = page.querySelector('[data-promo-count]');
    var empty = page.querySelector('[data-promo-empty]');
    if (!banners.length) return;

    function apply(filter) {
        var shown = 0;
        banners.forEach(function (banner) {
            var tags = ' ' + (banner.getAttribute('data-promo-tags') || '') + ' ';
            var match = filter === 'all' || tags.indexOf(' ' + filter + ' ') !== -1;
            banner.hidden = !match;
            if (match) shown += 1;
        });
        chips.forEach(function (chip) {
            chip.setAttribute('aria-pressed', chip.getAttribute('data-promo-filter') === filter ? 'true' : 'false');
        });
        if (count) count.textContent = shown;
        if (empty) empty.hidden = shown > 0;
    }

    // Cả chip lẫn nút "xem tất cả" trong dòng trống
    page.addEventListener('click', function (event) {
        var trigger = event.target.closest ? event.target.closest('[data-promo-filter]') : null;
        if (trigger) apply(trigger.getAttribute('data-promo-filter'));
    });
})();
